import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page-wrap p-3" }
const _hoisted_2 = { class: "page-header p-3 mb-3 mt-3" }
const _hoisted_3 = { class: "add-item-block mt-3 mb-3 d-flex justify-content-end flex-wrap gap-3" }
const _hoisted_4 = { class: "me-3" }
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_vue_loading = _resolveComponent("vue-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Сводный отчёт (Соц)", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("label", { class: "form-label" }, "Год", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
            class: "form-select"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (y) => {
              return (_openBlock(), _createElementBlock("option", {
                key: y,
                value: y
              }, _toDisplayString(y), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.year]
          ])
        ]),
        _createVNode(_component_b_button, {
          variant: "success",
          disabled: _ctx.isLoading,
          onClick: _ctx.downloadSocial
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Сформировать «Соц категории» ")
          ])),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _createVNode(_component_vue_loading, {
      active: _ctx.isLoading,
      "is-full-page": true
    }, null, 8, ["active"])
  ]))
}